import React from 'react';
import { Typography, colors } from '@material-ui/core';

const ErrorMessage = ({ children }) => {
  return (
    <Typography variant="subtitle1" style={{ color: colors.red[900] }}>
      <b>{children}</b>
    </Typography>
  );
};

export default ErrorMessage;
